module.exports = __webpack_public_path__ + "static/media/TBI.87be1259.webp";